import React, { useEffect, useState } from 'react';
import Profile from './Profile';
import Payments from './Payments';
import Subscriptions from './Subscriptions';
import Notifications from './Notifications';
import ServiceAddresses from './ServiceAddresses';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  AdjustmentsHorizontalIcon,
  ArrowPathIcon,
  BellIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  ExclamationTriangleIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import CreditCard from '../../components/Icons/CreditCard';
import Settings from './Settings';
import { useLocation } from 'react-router-dom';
import AddAddressActionBar from '../../components/AddAddressActionBar';

export default function MyAccount() {
  const { allServiceAddresses } = useSelector((state) => state.serviceAddresses);
  const { newSubscriptionId } = useSelector((state) => state.createNewOrder);
  const { profileData } = useSelector((state) => state.profile);
  const [allLocations, setAllLocations] = useState([]);
  const location = useLocation();
  const [tabs, setTabs] = useState([
    { name: 'Profile', active: true },
    { name: 'Payments', active: false },
    { name: 'Subscriptions', active: false },
    { name: 'ServiceAddress', active: false },
    { name: 'Settings', active: false },
    { name: 'Notifications', active: false },
  ]);
  const setActiveTab = (name) => {
    const updatedTabs = tabs.map((tab) => {
      if (tab.name === name) {
        tab.active = true;
      } else {
        tab.active = false;
      }
      return tab;
    });
    setNewAddress(false);
    setTabs(updatedTabs);
  };
  const [newAddress, setNewAddress] = useState(false);
  const newAddressFn = (val) => {
    setActiveTab('ServiceAddress');
    setNewAddress(true);
  };
  useEffect(() => {}, [newAddress]);
  useEffect(() => {
    if (allServiceAddresses) {
      const locations = allServiceAddresses.map((address) => {
        return {
          id: address.id,
          value: `${address?.name}, ${address?.address_line_1}`,
        };
      });
      setAllLocations(locations);
    }
  }, [allServiceAddresses]);

  useEffect(() => {
    if (!isEmpty(profileData?.past_due_invoices)) {
      setActiveTab('Payments');
    }
  }, [profileData?.past_due_invoices]);
  useEffect(() => {
    if (newSubscriptionId) {
      setActiveTab('Subscriptions');
    }
  }, [newSubscriptionId]);

  useEffect(() => {
    if (location?.state?.from && location.pathname === '/account') {
      setActiveTab('Payments');
    }
  }, [location?.state?.from]);

  const renderTab = (tabname) => {
    switch (tabname) {
      case 'Profile':
        return <Profile setActiveTab={setActiveTab} />;
      case 'Payments':
        return <Payments setActiveTab={setActiveTab} allLocations={allLocations} />;
      case 'Subscriptions':
        return <Subscriptions setActiveTab={setActiveTab} allLocations={allLocations} />;
      case 'Notifications':
        return <Notifications />;
      case 'ServiceAddress':
        return (
          <ServiceAddresses
            newaddress={newAddress}
            cancelNewAddress={(val) => setNewAddress(val)}
            setTabs={setActiveTab}
          />
        );
      case 'Settings':
        return <Settings setActiveTab={setActiveTab} allLocations={allLocations} />;

      default:
        return <Profile />;
    }
  };

  const iconsSwitch = (tabname) => {
    switch (tabname) {
      case 'Profile':
        return <UserIcon className='inline-block h-5 w-5' strokeWidth={2} />;
      case 'Payments':
        return <CreditCardIcon className='inline-block h-5 w-5' strokeWidth={2} />;
      case 'Subscriptions':
        return <ArrowPathIcon className='inline-block h-5 w-5' strokeWidth={2} />;
      case 'Preferences':
        return <AdjustmentsHorizontalIcon className='inline-block h-5 w-5' strokeWidth={2} />;
      case 'Notifications':
        return <BellIcon className='inline-block h-5 w-5' strokeWidth={2} />;
      case 'Settings':
        return <Cog6ToothIcon className='inline-block h-5 w-5' strokeWidth={2} />;
      default:
        return null;
    }
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  return (
    <>
      <div className='mb-4 flex flex-col justify-between bg-white sm:mb-6 sm:flex-row'>
        <ul className='mx-4 mb-4 flex flex-wrap sm:mx-6'>
          {tabs.map((tab, index) => {
            if (tab.name != 'ServiceAddress') {
              return (
                <li
                  className={`${
                    tab.active ? 'text-client-primarylight  bg-blue-100 ' : ' text-gray-800'
                  }   go-textblack-15 cursor-pointer rounded-lg bg-white py-2 px-2 text-center sm:w-32  `}
                  onClick={() => setActiveTab(tab.name)}
                  key={index}
                >
                  {iconsSwitch(tab.name)}
                  <div
                    className={`mt-1 flex justify-center ${
                      tab.active ? 'go-textblack-15 text-client-primarylight' : ' go-label-15'
                    }`}
                  >
                    {tab.name}
                  </div>
                </li>
              );
            }
          })}
        </ul>
      </div>
      {renderTab(tabs.find((tab) => tab.active).name)}
    </>
  );
}
